import React, { useState, useEffect } from 'react';
import { Button, Col, Container, Image, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import ImageGallery from 'react-image-gallery';
import clsx from 'clsx';
import prefetchImages from 'prefetch-image';

export default function HotelHeaderImage({ photoList }) {
  const [desktopFullScreen, setDesktopFullScreen] = useState(false);
  function fullScreen() {
    setDesktopFullScreen(!desktopFullScreen);
  }
  const [galleryImages, setGalleryImages] = useState([]);

  useEffect(() => {
    const galleryImagesPromise = prefetchImages(photoList);
    galleryImagesPromise.then((result) => {
      const images = result
        .filter((photo) => photo.complete && photo.naturalWidth !== 0)
        .map((photo) => ({
          original: photo.src.replace('max1024x768', 'max1024x900'),
          thumbnail: photo.src.replace('max1024x768', 'max1024x300'),
        }));
      setGalleryImages(images);
    });
  }, [photoList]);

  return (
    <Container fluid className="mt-4">
      <FontAwesomeIcon icon={faXmark} className={clsx({ 'd-md-none': !desktopFullScreen, 'exit-fullscreen': true })} onClick={() => fullScreen()} />{' '}
      <div
        className={clsx({
          'd-md-none': !desktopFullScreen,
          'header-image-gallery': true,
        })}
      >
        <ImageGallery showNav thumbnailPosition="left" items={galleryImages} showBullets />
      </div>
      <div className={clsx({ 'd-md-none': desktopFullScreen, 'd-md-block': true })}>
        <Row className="gx-12 header-image">
          {galleryImages.length > 0 ? (
            galleryImages.slice(0, 3).map((photo) => {
              return (
                <Col md={4} className="col-hotel-header-img" key={photo}>
                  <Image md={4} src={photo.original.replace('max1024x768', 'max1024x900')} cover="true" className="img-fluid" />
                  <div className="hotel-header-img-overlay">
                    <Button onClick={() => fullScreen()} variant="outline-dark" className="position-absolute position-absolute top-50 start-50 translate-middle image-fullscreen-button">
                      SHOW MORE
                    </Button>
                  </div>
                </Col>
              );
            })
          ) : (
            <div className="col-hotel-header-img">
              <Image src="https://foodfan.s3.amazonaws.com/2019/hotel_header_bg_small.jpg" className="blur" />
            </div>
          )}
        </Row>
      </div>
    </Container>
  );
}
